export const QUERY_KEY_INTERACTION_AGGREGATES = 'interactionAggregates';
export const QUERY_KEY_MULTI_AGGREGATES = 'multiAggregates';
export const QUERY_KEY_USER_QUERIES = 'userQueries';
export const QUERY_KEY_INTERACTION_DETAILS = 'interactionDetails';
export const QUERY_KEY_CONVERSATION_DETAILS = 'conversationDetails';
export const QUERY_KEY_CONVERSATION_INTERACTIONS = 'conversationInteractions';
export const QUERY_KEY_AUDIENCES_INTERACTIONS = 'audiencesInteractions';
export const QUERY_KEY_INTENTS_KEYWORDS = 'intentsKeywords';
export const QUERY_KEY_RETENTION = 'retention';
export const QUERY_KEY_INTENTS_BASE = 'intents';
export const QUERY_KEY_RED_FLAG_INTENTS_BASE = 'negative_intents';
export const QUERY_KEY_CHART = 'chartData';
export const QUERY_KEY_FILTER_CUSTOM_COLUMNS = 'filterCustomColumns';
export const QUERY_KEY_FILTER_CONVERSATION_CUSTOM_COLUMNS = 'filterConversationCustomColumns';
export const QUERY_KEY_FILTER_AVAILABLE_CUSTOM_AGGREGATES = 'filterAvailableCustomAggregates';
export const QUERY_KEY_AVAILABLE_TAGS = 'availableTags';
export const QUERY_KEY_AVAILABLE_FILTERS = 'availableFilters';
export const QUERY_KEY_FETCH_CUSTOM_AGGREGATE_CATEGORIES = 'fetchCustomAggregateCategories';
export const QUERY_KEY_FETCH_UNPROCCESSED_CUSTOM_AGGREGATES_CATEGORIES = 'fetchUnprocessedCustomAggregatesCategories';
export const QUERY_KEY_EXCLUDED_FILTERS = 'excludedFilters';
export const QUERY_KEY_CONFIGURATION = 'configuration';
export const QUERY_KEY_INTERACTION_TIME_SERIES = 'interactionTimeSeries';
export const QUERY_KEY_USER_INTENTS_PAGE__INTENTS = 'userIntents_intents';
export const QUERY_KEY_USER_INTENTS_PAGE__ACTIONS = 'userIntents_actions';
export const QUERY_KEY_USER_USER_INTELLIGENCE_VERTICAL_TABLE__TOPICS = 'userIntelligenceVerticalTable_topics';
export const QUERY_KEY_USER_USER_INTELLIGENCE_VERTICAL_TABLE__RISKY_BEHAVIORS =
  'userIntelligenceVerticalTable_riskyBehaviors';
export const QUERY_KEY_USER_USER_INTELLIGENCE_VERTICAL_TABLE__ACTIONS = 'userIntelligenceVerticalTable_actions';
export const QUERY_KEY_USER_INTENTS_PAGE__TOTALS = 'userIntents_totals';
export const QUERY_KEY_USER_TOPIC__TOTALS = 'topic_totals';
export const QUERY_KEY_REPORT_DEFAULT_TEMPLATES = 'reportQueryDefaultTemplates';
export const QUERY_KEY_REPORT_CUSTOM_TEMPLATES = 'reportQueryCustomTemplates';
export const QUERY_KEY_REPORT_TAG_TEMPLATES = 'reportQueryTagTemplates';
export const QUERY_KEY_REPORT = 'reportQuery';
export const QUERY_KEY_REPORT_SELECTED_CHART_CONFIG = 'reportSelectedChartConfig';
export const QUERY_KEY_CHART_REPORT_DATA = 'chartReportData';
export const QUERY_KEY_SETTINGS_REPORT = 'settingsReportQuery';
export const QUERY_KEY_REPORTS = 'reportsQuery';
export const QUERY_KEY_DETAILED_REPORTS = 'detailedReports';
export const QUERY_KEY_COHORTS = ['cohorts'];
export const QUERY_KEY_COHORT_USERS = 'cohortUsers';
export const QUERY_KEY_ORGANIZATIONS = 'organizations';
export const QUERY_KEY_SAVED_FILTERS = 'savedFilters';
export const QUERY_KEY_ORGANIZATION_ID = 'organizationId';
export const QUERY_KEY_ORGANIZATION_AGGREGATES = 'organizationAggregates';
export const QUERY_KEY_ORGANIZATION_REPORTS = 'organizationReports';
export const QUERY_KEY_ORGANIZATION_PROJECTS = 'organizationProjects';
export const QUERY_KEY_MEMBERS_TABLE = 'membersTable';
export const QUERY_KEY_USERS = 'users';
export const QUERY_KEY_DEFAULT_TIMERANGE = 'defaultTimeRange';
export const QUERY_KEY_GET_COHORTS_V2 = 'getCohortsV2';
export const QUERY_KEY_GET_COHORTS_USERS = 'getCohortsUsers';
export const QUERY_KEY_GET_SYSTEM_KIND_USERS = 'getSystemKindUsers';
export const QUERY_KEY_GET_AI_SUMMARY = 'getAISummary';
export const QUERY_KEY_WARNING_CAT = 'warningscategories';
export const QUERY_KEY_SUGGESTIONS = 'suggestions';
export const QUERY_KEY_WARNINGS_AGGREGATES = 'warningAggregates';
export const QUERY_KEY_SHARED_PAGES_FILTER_VALUES = 'sharedPagesFilterValues';
export const QUERY_KEY_FETCH_ANALYTICS_CHART_DATA = 'fetchAnalyticsChartData';
export const QUERY_KEY_FETCH_SHARED_PAGES = 'fetchSharedPages';
export const QUERY_KEY_INNER_DATATABLE_ROWS = 'innerDataTableRows';
export const QUERY_KEY_CHART_EVENTS = 'chartEvents';
export const QUERY_KEY_PROJECT_USERS = 'projectUsers';
export const QUERY_KEY_PLATFORM_SEARCH = 'platformSearch';
export const QUERY_KEY_GET_CATEGORY = 'getCategory';
export const QUERY_KEY_FAVORITE_REPORTS = 'favoriteReports';
export const QUERY_KEY_DEFAULT_REPORTS = 'defaultReports';
export const QUERY_KEY_EXPLORE_SORT_BY = 'exploreSortBy';
export const QUERY_KEY_EXPLORE_PAGE_INDEX = 'explorePageIndex';
export const QUERY_KEY_EXPLORE_PAGE_SIZE = 'explorePageSize';
export const QUERY_KEY_ALERT_SETTINGS = 'alertSettings';
export const QUERY_KEY_PROJECT_CONFIG = 'projectConfig';
export const QUERY_KEY_ROI_TAXONOMY = 'roi-taxonomy';
export const QUERY_KEY_ROI_TAXONOMY_GROUPS = 'roi-taxonomy-groups';
export const QUERY_KEY_ROI_HOURLY_COST_GROUPS = 'roi-hourly-cost-groups';
export const QUERY_KEY_ROI_HOURLY_COST_TAG_VALUES = 'roi-hourly-cost-tag-values';
